var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 277,
    viewBox: "0 0 384 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.700204 258.299C14.5002 238.199 29.5002 253.799 29.3002 264.799C3.80018 294.999 -0.799796 259.399 0.700204 258.299Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 0.0301234,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.5005 261.6C54.4004 272.4 36.6005 273.199 26.9005 264.899C19.8005 258.799 18.3004 248.799 17.1004 241.199C16.2004 235.199 15.4004 229.3 19.1004 225.6C22.2004 222.5 26.8005 222.299 28.9005 222.399C46.5005 212.599 63.2004 212.299 69.6004 219.899C70.9004 221.499 72.5005 224.199 72.7005 228.999C73.1005 238.699 76.6005 259.9 69.5005 261.6Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 0.0634656,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M356.5 241.7C270.7 252.3 214.8 250.5 178.8 246.6C155.2 244 149.3 241.5 122.8 239.9C69.3002 236.5 37.7002 244 28.9002 226.6C26.3002 221.4 26.3002 215.3 26.4002 203.3C26.5002 182 32.8002 173.9 34.7002 155.8C37.2002 132 32.4002 115 34.6002 102.3C37.8002 77.1001 63.5002 63.5001 79.1002 62.3001C90.8002 52.3001 104.8 61.1 116.3 53.5C154.4 48.6 185.4 47.9 206.5 48.2C219.3 48.4 230.9 49.0001 277.8 52.1001C301.7 53.7001 322.2 55.1001 337.9 56.3001C347.7 57.0001 356.7 62.3001 362 70.6001C368.5 80.7001 372.6 89.7001 375.3 96.3001C378.2 103.6 380.6 111.2 383.6 190.9C384.1 205.1 384.5 218.2 375.6 229.1C369.8 236.4 361.9 239.9 356.5 241.7Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 0.325,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M49.6001 1.49971C77.7001 8.19971 96.8001 28.2997 97.0001 47.9997C97.1001 62.4997 86.9001 74.4998 79.2001 83.5998C74.3001 89.3998 68.3001 95.5997 58.8001 97.1997C51.6001 98.3997 45.4001 96.3997 42.0001 94.9997C38.4001 92.9997 32.5001 89.3997 26.0001 83.9997C17.6001 76.9997 -2.29991 60.3997 0.500093 43.6997C0.900093 41.1997 1.10009 36.7997 8.00009 30.6997C19.2001 20.6997 40.5001 -5.10029 49.6001 1.49971Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 0.09873,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9008 67.7011C52.2008 68.8011 52.1008 70.6012 52.0008 71.0012C51.8008 72.9012 50.2008 73.9012 50.0008 74.0012C48.5008 74.4012 47.0008 74.0012 46.0008 73.0012C45.9008 72.8012 44.8008 71.7012 45.0008 70.0012C45.2008 68.4012 46.6008 67.3012 48.0008 67.0012C48.2008 67.0012 49.7008 66.7011 50.9008 67.7011Z",
    fill: "#E6EDE4",
    stroke: "#F2F8F0",
    strokeWidth: 2.0974,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2005 60.4004C45.8005 60.1004 45.1005 59.4005 45.0005 54.0005C45.0005 52.7005 45.0005 52.1005 45.0005 50.0005C45.0005 50.0005 45.0005 50.0005 45.0005 42.0005C45.0005 40.0005 45.0005 38.0005 45.0005 36.0005C45.0005 35.5005 44.9005 32.1005 45.0005 28.0005C45.0005 26.1005 45.1005 24.5005 46.0005 23.0005C46.3005 22.4005 47.0005 21.4005 48.3005 21.0005C48.4005 21.0005 49.3005 20.7005 50.0005 21.0005C51.8005 21.7005 51.9005 25.3005 52.0005 27.0005C52.2005 33.3005 52.0005 36.8005 52.0005 40.0005C52.0005 43.0005 52.2005 48.9005 52.0005 56.0005C52.0005 57.2005 51.9005 59.2006 50.4005 60.3006C49.3005 61.1006 47.3005 61.2004 46.2005 60.4004Z",
    fill: "#E6EDE4",
    stroke: "#F2F8F0",
    strokeWidth: 1.9867,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.8c0589baa45e21960093a18c827a995d.svg";
export { ForwardRef as ReactComponent };